__turbopack_context__.v({
  "checkbox": "OhQoza_checkbox",
  "dash": "OhQoza_dash",
  "indicator": "OhQoza_indicator",
  "tick": "OhQoza_tick",
});
